import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Feeling",
    opening: localizedGenderNode(
      [
      "Today I notice the feeling of failure.",
      "Just noticing.",
      "I am here."
    ],
      [
      "Today I notice the feeling of failure.",
      "Just noticing.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does this feeling rise most?",
      "What do I tell myself then?",
      "Where does it sit in my body?"
    ],
      [
      "When does this feeling rise most?",
      "What do I tell myself then?",
      "Where does it sit in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A feeling is a feeling, not an identity."
    ],
      [
      "A feeling is a feeling, not an identity."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I am here\".",
      "one breath + \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The Trigger Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the feeling lights up.",
      "Just seeing it.",
      "I stay with myself."
    ],
      [
      "Today I notice the moment the feeling lights up.",
      "Just seeing it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happened right before it started?",
      "What sentence about me jumps in?",
      "What do I feel then?"
    ],
      [
      "What happened right before it started?",
      "What sentence about me jumps in?",
      "What do I feel then?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a small space."
    ],
      [
      "In the first moment I have a small space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when the feeling rises.",
      "one breath when the feeling rises."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "My Body",
    opening: localizedGenderNode(
      [
      "Today I listen to my body when failure is felt.",
      "Not to fix it.",
      "I am here."
    ],
      [
      "Today I listen to my body when failure is felt.",
      "Not to fix it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does my body hold the feeling?",
      "What does my body need in that moment?",
      "What could soften a little?"
    ],
      [
      "Where does my body hold the feeling?",
      "What does my body need in that moment?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to keep me safe."
    ],
      [
      "My body is trying to keep me safe."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Fact vs. Story",
    opening: localizedGenderNode(
      [
      "Today I separate fact from the story about me.",
      "Without fighting it.",
      "I am here."
    ],
      [
      "Today I separate fact from the story about me.",
      "Without fighting it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the simple fact here?",
      "What story jumps about me?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the simple fact here?",
      "What story jumps about me?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is interpretation\".",
      "an inner sentence - \"This is interpretation\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Cost",
    opening: localizedGenderNode(
      [
      "Today I see the cost of the failure feeling.",
      "Without punishment.",
      "I am here."
    ],
      [
      "Today I see the cost of the failure feeling.",
      "Without punishment.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders a little.",
      "One breath."
    ],
      [
      "I soften my shoulders a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does this take from me?",
      "Where do I get smaller?",
      "What would I like to return to myself?"
    ],
      [
      "What does this take from me?",
      "Where do I get smaller?",
      "What would I like to return to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the cost is a step of compassion."
    ],
      [
      "Seeing the cost is a step of compassion."
    ]
    ),
    action: localizedGenderNode(
      "one word about what I return.",
      "one word about what I return."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Triggers",
    opening: localizedGenderNode(
      [
      "Today I notice what triggers the failure feeling.",
      "Just noticing.",
      "I am here."
    ],
      [
      "Today I notice what triggers the failure feeling.",
      "Just noticing.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does it flare up most?",
      "What situation or person triggers me?",
      "What do I need in that moment?"
    ],
      [
      "When does it flare up most?",
      "What situation or person triggers me?",
      "What do I need in that moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I notice a trigger, I have a small space."
    ],
      [
      "When I notice a trigger, I have a small space."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest when it rises.",
      "a hand on my chest when it rises."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A Gentle Boundary",
    opening: localizedGenderNode(
      [
      "Today I set a gentle boundary with the failure voice.",
      "Quietly.",
      "I am here."
    ],
      [
      "Today I set a gentle boundary with the failure voice.",
      "Quietly.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back supported.",
      "One breath."
    ],
      [
      "I feel my back supported.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which sentences are too much for me?",
      "What boundary do I want to set?",
      "How do I say it to myself?"
    ],
      [
      "Which sentences are too much for me?",
      "What boundary do I want to set?",
      "How do I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner boundary is protection, not a war."
    ],
      [
      "An inner boundary is protection, not a war."
    ]
    ),
    action: localizedGenderNode(
      "say \"I do not speak to myself like that\".",
      "say \"I do not speak to myself like that\"."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Small Compassion",
    opening: localizedGenderNode(
      [
      "Today I try to speak to myself gently.",
      "Even if it is new.",
      "I am here."
    ],
      [
      "Today I try to speak to myself gently.",
      "Even if it is new.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What shifts in me when I hear it?"
    ],
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What shifts in me when I hear it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One gentle word is enough to begin."
    ],
      [
      "One gentle word is enough to begin."
    ]
    ),
    action: localizedGenderNode(
      "one soft sentence to myself.",
      "one soft sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Seeing the Good",
    opening: localizedGenderNode(
      [
      "Today I make space for small goodness in me.",
      "Without exaggeration.",
      "I am here."
    ],
      [
      "Today I make space for small goodness in me.",
      "Without exaggeration.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I hear my breath.",
      "One breath."
    ],
      [
      "I hear my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is one good thing in me today?",
      "Where is it felt in my body?",
      "What do I carry from it?"
    ],
      [
      "What is one good thing in me today?",
      "Where is it felt in my body?",
      "What do I carry from it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small good is enough to begin."
    ],
      [
      "A small good is enough to begin."
    ]
    ),
    action: localizedGenderNode(
      "write one word of good.",
      "write one word of good."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Request to Myself",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Not a demand.",
      "I stay with myself."
    ],
      [
      "Today I give myself one clear request.",
      "Not a demand.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can soften the day."
    ],
      [
      "One request can soften the day."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Shift",
    opening: localizedGenderNode(
      [
      "Today I choose a small shift within the day.",
      "Not a revolution.",
      "I am here."
    ],
      [
      "Today I choose a small shift within the day.",
      "Not a revolution.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice one point of contact in my body.",
      "One breath."
    ],
      [
      "I notice one point of contact in my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small shift am I willing to try today?",
      "When is it easiest to try it?",
      "What will gently remind me to choose it?"
    ],
      [
      "What small shift am I willing to try today?",
      "When is it easiest to try it?",
      "What will gently remind me to choose it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small shift is a gentle movement."
    ],
      [
      "A small shift is a gentle movement."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment to try it.",
      "choose one moment to try it."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Being Human",
    opening: localizedGenderNode(
      [
      "Today I make space for being human.",
      "Without dismissing it.",
      "I am here."
    ],
      [
      "Today I make space for being human.",
      "Without dismissing it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would happen if I allowed myself to be human?",
      "What would that release in me?",
      "What gentleness can I give myself?"
    ],
      [
      "What would happen if I allowed myself to be human?",
      "What would that release in me?",
      "What gentleness can I give myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being human is not a failure."
    ],
      [
      "Being human is not a failure."
    ]
    ),
    action: localizedGenderNode(
      "one permission sentence to myself.",
      "one permission sentence to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Practice",
    opening: localizedGenderNode(
      [
      "Today I choose a small practice that softens the feeling.",
      "Simple.",
      "I am here."
    ],
      [
      "Today I choose a small practice that softens the feeling.",
      "Simple.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my sitting.",
      "One breath."
    ],
      [
      "I feel my sitting.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small practice could help me today?",
      "When in the day do I do it?",
      "What will gently remind me?"
    ],
      [
      "What small practice could help me today?",
      "When in the day do I do it?",
      "What will gently remind me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small practice creates a gentle change."
    ],
      [
      "A small practice creates a gentle change."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment for the practice.",
      "choose one moment for the practice."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ],
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about the failure feeling?",
      "What is the early sign it returns?",
      "Return sentence for the moment before - what do I say to myself?"
    ],
      [
      "What did I learn about the failure feeling?",
      "What is the early sign it returns?",
      "Return sentence for the moment before - what do I say to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can make mistakes and still stay with myself."
    ],
      [
      "I can make mistakes and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "one breath before responding.",
      "one breath before responding."
    ),
  },
].map(buildNormalizedDay);

export const chronicFeelingOfFailureBlueprintEn = buildNormalizedPilotBlueprint({
  id: "chronic_feeling_of_failure_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "chronic_feeling_of_failure",
  category: "self_worth",
  journeyName: {
    he: "תחושת כישלון כרונית",
    en: "Chronic feeling of failure",
    es: "Sensación crónica de fracaso",
  },
  days,
});

export default chronicFeelingOfFailureBlueprintEn;
